// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/radio-failure.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/radio-failure/radio-failure.js';

mount([g0]);
